//      
export { default } from './placeholder';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/placeholder/index.js